import React from 'react';

import {IMemoizedPhoneCodeOptions} from './IMemoizedPhoneCodeOptions';

const PhoneCodeOptions = ({phoneCodes}:IMemoizedPhoneCodeOptions ) => {
	return (
		<>
			{phoneCodes.map((phoneCode) =>
				<option key={phoneCode.code} value={phoneCode.code}>{phoneCode.code}</option>
			)}
		</>
	);
};

const MemoizedPhoneCodeOptions = React.memo(PhoneCodeOptions);

export default MemoizedPhoneCodeOptions;
